// CB1000GT Store: quick-add for the minimum-order suggestions (snippets/cb-min-order.liquid).
// Uses one delegated listener, so it keeps working after the cart drawer/page is re-rendered.
import { CartAddEvent } from '@theme/events';

document.addEventListener('click', async (event) => {
  const button = event.target instanceof Element ? event.target.closest('[data-cb-min-add]') : null;
  if (!(button instanceof HTMLButtonElement) || button.disabled) return;

  event.preventDefault();
  button.disabled = true;

  const variantId = button.dataset.cbMinAdd;
  // `Theme` is a global const from snippets/scripts.liquid (not on window); routes carry the locale prefix.
  const routes = typeof Theme !== 'undefined' ? Theme.routes : {};
  const addUrl = routes.cart_add_url || '/cart/add.js';
  const cartUrl = `${routes.cart_url || '/cart'}.js`;

  try {
    const response = await fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
    });
    if (!response.ok) throw new Error(`cart/add ${response.status}`);

    const cart = await fetch(cartUrl, { headers: { Accept: 'application/json' } }).then((res) => res.json());

    // No `sections` in the payload: the cart drawer and cart page re-render themselves.
    document.dispatchEvent(
      new CartAddEvent(cart, 'cb-min-order', {
        source: 'cb-min-order',
        itemCount: cart.item_count,
        variantId,
      })
    );
  } catch (error) {
    console.error('[cb-min-order]', error);
    button.disabled = false;
  }
});
